import React from 'react';
import { TableLegendRowContextValue } from './TableLegend.types';

export const TableLegendRowContext = React.createContext<TableLegendRowContextValue | null>(null);

export const useTableLegendRow = <D = unknown>() => {
  const ctx = React.useContext(TableLegendRowContext);
  if (!ctx) throw new Error('useTableLegendRow must be used within a <TableLegendRow>');
  return ctx as TableLegendRowContextValue<D>;
};
